import classnames from 'classnames';
import { SfaPenaltyDotProps } from './sfaPenaltyDot.types';
import styles from './sfaPenaltyDot.module.scss';

const SfaPenaltyDot = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-penalty-dot',
  result,
}: SfaPenaltyDotProps) => (
  <span
    {...nativeProps}
    data-testid={testId}
    className={classnames(
      styles.sfaPenaltyDot,
      styles[`sfaPenaltyDot--${result}`],
      classNames
    )}
  />
);

export default SfaPenaltyDot;
